var $ = jQuery.noConflict();

function smoothScrollTo(sel, offset) {
    $('html, body').animate({
        scrollTop: $(sel).offset().top + offset
    }, 500, 'swing');
}

/* Srcset implementation for background-image */

function imageCurrentSrc(el) {
    var img = $(el);
    return typeof img.prop('currentSrc') !== 'undefined' ? img.prop('currentSrc') : img.attr('src');
}

function imageToBackgroundImage(e) {
    var img = e instanceof Event ? e.target : e;
    var container = $(img).parents('.js-bg');
    if ($(img).is('.js-bg__img') || container.find('img').length == 1) {
        container.css('background-image', 'url(' + imageCurrentSrc(img) + ')');
        $(img).hide();
    }
}

/* Srcset implementation for background-image */
function switchSrc(el, parent) {
    var img = $(el);
    var src = typeof img.prop('currentSrc') !== 'undefined' ? img.prop('currentSrc') : img.attr('src');
    $(img).parents(parent).css('background-image', 'url(' + src + ')');
    img.hide();
}

function checkBackgroundImages(params) {
    $('.js-bg').each(function () {
        var imgs = $(this).find('.js-bg__img').length ? $(this).find('.js-bg__img') : $(this).find('img');
        imgs.on('load', function () {
            switchSrc(this, '.js-bg');
        }).each(function () {
            if (this.complete) {
                switchSrc(this, '.js-bg');
            }
        });
    });
}

$(function () {

    /* Back to top button management */

    $('.js-go-up').click(function () {
        smoothScrollTo($('body'), 0)
    });

    $(window).scroll(function () {
        if ($(this).scrollTop() >= $(this).height())
            $('.js-go-up').addClass('in');
        else
            $('.js-go-up').removeClass('in');
    });

    /* Sliders management */

    var slider_opt = {
        items: 1,
        loop: true,
        dots: false,
        nav: true,
        navElement: 'a',
        navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
        navClass: ['owl-prev', 'owl-next'],
        autoplay: false,
        mouseDrag: false,
        touchDrag: true,
        // autoplayHoverPause: true,
    };

    var sliders = $('.owl-carousel').filter(function () {
        return $(this).find('.slide').length > 1;
    });

    if (sliders.length) {
        sliders.each(function () {
            var slider = $(this);
            if (slider.is('.slider--main')) {
                slider.owlCarousel(
                    $.extend(
                        {},
                        slider_opt,
                        {
                            // autoplayTimeout: 6000,
                            autoplay: true,
                        }
                    )
                );
            } else {
                slider.owlCarousel(slider_opt);
            }
        });
    }

    /* Lightbox management */

    $('[data-toggle="lightbox"]').click(function (event) {
        event.preventDefault();
        $(this).ekkoLightbox({
            leftArrow: '<span class="fa fa-angle-left"></span>',
            rightArrow: '<span class="fa fa-angle-right"></span>',
        });
    });

    /* Page contained section menu management */

    $('.menu--article-section .nav-link[data-target]').click(function (e) {
        e.preventDefault();
        smoothScrollTo($(this).data('target'), -20);
    })

    // $('img').on('load', imageToBackgroundImage)
    //     .each(function () {
    //         if (this.complete) {
    //             imageToBackgroundImage(this);
    //         }
    //     });

    checkBackgroundImages();



    /* Cosa ti sei perso home page section */
    $(document).ready(function () {
        $('.home .things-left-behind ul li a.nav-link').click(function (e) {
            //action=highlight_widget&_nonce=1a60340ef0&highlight_category=videos
            var term_slug = $(this).data('event-category');
            var _nonce = $('.home section.things-left-behind').data('nonce');
            var action = $('.home section.things-left-behind').data('action');
            var data = {
                'action': action,
                '_nonce': _nonce,
                'event_category': term_slug
            };
            $.get(
                ajaxurl,
                data
            ).then(function (data) {
                category = data.category;
                $('.home .things-left-behind .section__body ul.showcase').empty();
                $('.home .things-left-behind .section__header li.nav-item a').removeClass('active');
                $('.home .things-left-behind .section__header li#nav-' + category + ' a').addClass('active');
                $('.home .things-left-behind .section__footer a').each(function () {
                    $(this).attr('href', data.category_permalink);
                });

                $.each(data.data, function (i, o) {
                    $li_showcase = $('<li class="showcase__item showcase__item--2--lg showcase__item--3--xl"></li>');
                    $('.home .things-left-behind .section__body ul.showcase').append($li_showcase.append(o));
                });
                checkBackgroundImages();

            });

            e.preventDefault();
            return false;
        });
    });
});